/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import { html, PolymerElement } from "../../@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "../../@polymer/polymer/lib/legacy/class.js";

class Myactions extends mixinBehaviors([sbBehaviours.retailDashboardBehavior], PolymerElement) {
    static get template() {
        return html`
        <style is="" include="app-styles">
                .dashboard-actions{
                border-radius: 4px !important;
            }
            
            .dashboard-actions.overdue-card {
                border: 1.5px solid var(--primary-color-but);               
                border-left: 4px solid var(--primary-color-but);
            }
            .dashboard-actions.overdue-card .secondary-dark-text-l {
                color: var(--primary-color-but);
                max-width: 70px;
            }
            .dashboard-actions .pay-string {
                color:var(--brand-color);   
                text-transform: uppercase;
            }
            .dashboard-actions.overdue-card .flex-1.text-overflow-ellipsis{
                border-left: 1px solid var(--primary-color-but);
            }

            .dashboard-actions.due-today-card {
                border: 1.5px solid var(--myaction-due-today);               
                border-left: 4px solid var(--myaction-due-today);
            }
            .dashboard-actions.due-today-card .secondary-dark-text-l {
                color: var(--myaction-due-today);
                max-width: 70px;
            }
            .dashboard-actions .pay-string {
                color:var(--brand-color);   
                text-transform: uppercase;
            }
            .dashboard-actions.due-today-card .flex-1.text-overflow-ellipsis{
                border-left: 1px solid var(--myaction-due-today);
               
            }

            .dashboard-actions.scheduled-card {
                border: 1.5px solid var(--brand-color);               
                border-left: 4px solid var(--brand-color);
            }
            .dashboard-actions.scheduled-card .secondary-dark-text-l {
                color: var(--brand-color);
                max-width: 70px;
            }
            .dashboard-actions .pay-string {
                color:var(--brand-color);   
                text-transform: uppercase;
            }
            .dashboard-actions.scheduled-card .flex-1.text-overflow-ellipsis{
                border-left: 1px solid var(--brand-color);
            }
            .due-since-text-height{
                height:54px;
            }
            .opacity-0 {
                opacity: 0;
            }
            paper-button{
                display: contents;
        }
        </style>
        <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
        <div class$="dashboard-actions {{finalList.classForValidation}}" phone$="{{phone}}" id="dashboard_user_actions_number_{{index}}">                                 
            <paper-card class="dashboard-actions-card round-icon-list-wrapper padding-8px" tablet$="{{tablet}}" desktop$="{{desktop}}" >
                <div class="mdl-grid padding-r-zero" menu-id="{{returnMenuId(finalList)}}">
                    <div class="horizontal center end-justified layout border-right">
                        <div class$="secondary-dark-text-l padding-t-zero padding-b-zero due-since-text-height content-align-vertical-center padding-l-zero font-size-s font-medium mdl-grid text-transform-uppercase {{finalList.classForDays}}">{{finalList.displayDays}}</div>
                    </div>
                    <div class="outlineOffset flex-1 mdl-grid padding-b-zero padding-t-zero text-overflow-ellipsis content-align-vertical-center position-relative" tabindex="0">
                        <div class="font-medium padding-lr-zero padding-t-zero primary-dark-text-m text-overflow-ellipsis full-width">{{finalList.displayName}}</div>
                        <div class="horizontal layout">
                            <span class="secondary-dark-text-xs">{{finalList.displayRemark}}</span>
                        </div>
                    </div>
                    <div class="horizontal center end-justified layout">
                        <div tabindex=0 role="menufinalList" aria-label$="{{getLabel('b_Pay')}} {{finalList.displayAmount}} {{finalList.displayDays}}" class="outlineOffset vertical center-justified end layout padding-7px mdl-grid madding-t-zero padding-b-zero">
                            <div class="cursor-pointer font-medium font-size-m mdl-grid padding-lr-zero padding-t-zero margin-r-zero"  id="dashboard_user_actions_amount_{{index}}">
                                <template is="dom-if" if="{{finalList.displayAmount}}">    
                                    <currency-formator format-value={{finalList.displayAmount}} formatting-amount="[[phone]]"></currency-formator>
                                </template>
                            </div>
                            <div>
                                <paper-button id$="action_button_{{actionIndex}}" class$="padding-zero secondary-dark-text-m pay-string {{finalList.classForDays}} font-size-m cursor-pointer" on-tap="_goToPayPage">{{finalList.payString}}</paper-button>
                            </div>
                        </div>
                    </div>      
                </div>  
            </paper-card>
        </div>
         `;
    }

    static get properties() {
        return {
            finalList: {
                type: Array,
                notify: true
            },
            actionIndex: {
                type: Number,
                notify: true
            }
        };
    }
    _goToPayPage(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        const item = this.finalList;
        var payURL = item.payURL;
        var payNavigationData = item.payNavigationData;
        var detailsURL = item.detailsURL;
        var detailsNavigationData = item.detailsNavigationData;
        window.navigate_from = {};
        window.navigate_from = "";
        if (detailsNavigationData && detailsNavigationData.isLoanNavigation) {
            this.getDataForIds(detailsNavigationData.loanAccountList, "/api/CBUsers/" + clientStorage.get(storageType.session, "userId") + "/loanaccounts", function (list) {
                detailsNavigationData.loanAccountList = list;
                for (var i = 0; i < list.length; i++) {
                    if (list[i].accountId === detailsNavigationData.selectedLoanAccount.accountId) {
                        detailsNavigationData.selectedLoanAccount = list[i];
                        break;
                    }
                }
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            });
        } else if (payNavigationData && payNavigationData.isIDCallRequired) {
            var self = this;
            self.dispatchEvent(new CustomEvent('start-processing-loader', {
                bubbles: true,
                composed: true
            }));
            var ajaxCall = document.createElement('oe-ajax');
            ajaxCall.contentType = "application/json";
            ajaxCall.handleAs = "json";
            ajaxCall.url = payNavigationData.idCallURL;
            ajaxCall.method = 'get';
            ajaxCall.addEventListener('response', function (event) {
                payNavigationData[payNavigationData.responseKey] = event.detail.response;
                window.oe_navigate_to(payURL, payNavigationData);
                self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                    bubbles: true,
                    composed: true
                }));
                e.stopPropagation();
            });
            ajaxCall.addEventListener("error", function (error) {
                self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                    bubbles: true,
                    composed: true
                }));
                showAjaxError(error);
                e.stopPropagation();
            });
            ajaxCall.generateRequest();
        } else if(item.productApplication){
            window.oe_navigate_to(item.navigateURL, item.navigateData);
        } else {
            window.oe_navigate_to(payURL, payNavigationData);
            e.stopPropagation();
        }
    }
    _setId(e) {
        if (e !== undefined) {
            const id = e.trim().replaceAll('*', '').replaceAll(' ', '_');
            return id;
        }
    }
}

window.customElements.define('app-my-actions', Myactions);
